import { Flex, Heading, Box } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';

import '../../styles/common.scss';

export const StratsTemplate = ({
  children,
  header,
}: {
  children: React.ReactNode;
  header: string;
}) => {
  return (
    <>
      <Box>
        <Flex justify="space-between">
          <Heading as="h2">{header}</Heading>
          <Box>
            <CreditFacilitySelect />
          </Box>
        </Flex>
      </Box>

      <Box>
        <Box mt="8" id="strats-template-wrapper">
          {children}
        </Box>
      </Box>
    </>
  );
};
